import { StyleSheet } from 'react-native';
import { FONTS } from '../../constants';
import { STYLE_VARS } from '../../constants/style-vars';
import { SCREEN_HEIGHT, SCREEN_WITDH } from '../../constants/platform';

export const myAccountStyled = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    // alignItems:'center',
  },
  headerWrapper: {
    width: '100%',
    alignItems: 'center',
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
  },
  headerTitle: {
    fontSize: 20,
    color: STYLE_VARS.primaryColor,
  },
  userInfoWrapper: {
    marginVertical: 20,
  },
  userInfoText: {
    fontSize: 20,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.primaryColor,
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: 4,
  },
  carInfoText: {
    fontSize: 16,
    fontStyle: 'italic',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
  },
  loadingScreen: {
    width: SCREEN_WITDH,
    height: SCREEN_HEIGHT,
    backgroundColor: STYLE_VARS.kccGrayTransparent,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
  },
});
